import Breadcrumbs from 'Components/Breadcrumbs'
import CustomButton from 'Components/CustomButton'
import ListActions from 'Components/ListActions'
import PageTitle from 'Components/PageTitle'
import TicketSaleDrawer from 'Services/SalesManagement/Features/TicketSale/Components/TicketSaleDrawer'
import TicketSaleList from 'Services/SalesManagement/Features/TicketSale/Components/TicketSaleList/TicketSaleList'
import useTicketSalesParams from 'Services/SalesManagement/Features/TicketSale/Hooks/useTicketSalesParams'
import { useGetTicketSalesQuery } from 'Services/SalesManagement/Features/TicketSale/ticketSaleApi'
import useListPage from 'Services/SalesManagement/Hooks/useListPage'
import useSalesManagementBreadcrumbs from 'Services/SalesManagement/Hooks/useSalesManagementBreadcrumbs'
import { SALES_MANAGEMENT_ROOT_URL } from 'Util/constants'
import AddIcon from '@mui/icons-material/Add'
import { Box } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { t } from 'ttag'

export default function TicketSaleListPage() {
  const navigate = useNavigate()
  const baseUrl = `${SALES_MANAGEMENT_ROOT_URL}/ticket-sales/qr-group-ticket-sales`
  const title = t`QR group ticket sales`

  const { params, setParams, selectedTicketSaleId, setSelectedTicketSaleId } =
    useTicketSalesParams()
  const { data, isFetching } = useGetTicketSalesQuery(params)

  const breadcrumbs = useSalesManagementBreadcrumbs([
    {
      title: t`Ticket sales`
    },
    { title }
  ])
  const { isDrawerOpen, handleRowClick, handleDrawerClose, handleChangePage, handleRequestSort } =
    useListPage({
      selectedId: selectedTicketSaleId,
      setSelectedId: setSelectedTicketSaleId,
      params,
      setParams
    })

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ mb: 2 }}>
        <Breadcrumbs items={breadcrumbs} />
        <PageTitle>{title}</PageTitle>
      </Box>
      <ListActions>
        <CustomButton
          onClick={() => navigate(`${baseUrl}/create`)}
          size="small"
          startIcon={<AddIcon />}
        >
          {t`Sell new QR group ticket`}
        </CustomButton>
      </ListActions>
      <Box pt={1}>
        <TicketSaleList
          rows={data?.results ?? []}
          isLoading={isFetching}
          params={params}
          handleRequestSort={handleRequestSort}
          handleChangePage={handleChangePage}
          count={data?.count ?? 0}
          page={params.page - 1}
          onRowClick={handleRowClick}
          selectedTicketSaleId={selectedTicketSaleId}
        />
      </Box>
      <TicketSaleDrawer
        open={isDrawerOpen}
        handleClose={handleDrawerClose}
        selectedTicketSaleId={selectedTicketSaleId}
      />
    </Box>
  )
}
